import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'most-popupar-badge',
  templateUrl: './most-popupar-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MostPopuparBadgeComponent {}
